import { createBrowserHistory } from "history"
import { useRouterHistory } from 'react-router'

export let history = createBrowserHistory()
